"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8220],{

/***/ 18220:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "FloatingWhatsapp": function() { return /* binding */ FloatingWhatsapp; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(785893);
/* harmony import */ var _redux_actions__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(467936);
/* harmony import */ var _utils_deviceWidth__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(186812);
/* harmony import */ var _utils_constants__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(913886);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(225617);
/* harmony import */ var src_hooks_useStoreContactDetails__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(299375);
/* harmony import */ var _utils_getWhatsAppRedirectionUrl__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(230066);
/* harmony import */ var src_hooks_useStoreSubscriptionConfigs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(372988);








var FloatingWhatsapp = function(props) {
    var dispatch = (0,react_redux__WEBPACK_IMPORTED_MODULE_3__/* .useDispatch */ .I0)();
    var storePhone = (0,src_hooks_useStoreContactDetails__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)().storePhone;
    var websiteStatus = (0,src_hooks_useStoreSubscriptionConfigs__WEBPACK_IMPORTED_MODULE_6__/* .useStoreSubscriptionConfigs */ .D)().websiteStatus;
    var ref = (0,react_redux__WEBPACK_IMPORTED_MODULE_3__/* .useSelector */ .v9)(function(state) {
        return {
            storeData: state.storeReducer.store,
            userData: state.userReducer
        };
    }), _storeData = ref.storeData, store_info = _storeData.store_info, store_id = _storeData.store_id, userData = ref.userData;
    var iconClick = function() {
        if (storePhone) {
            var ref;
            dispatch((0,_redux_actions__WEBPACK_IMPORTED_MODULE_7__/* .pushEventsLog */ .U)({
                event_name: "Cx_WA_Clicked",
                data: {
                    store_id: store_id,
                    domain: store_info === null || store_info === void 0 ? void 0 : store_info.domain,
                    page: window.location.href,
                    device: _utils_deviceWidth__WEBPACK_IMPORTED_MODULE_1__/* .deviceWidth */ .o <= _utils_constants__WEBPACK_IMPORTED_MODULE_2__/* .MAX_MOBILE_WIDTH */ .Cf ? "Mobile" : "Desktop",
                    cx_number: userData === null || userData === void 0 ? void 0 : (ref = userData.data) === null || ref === void 0 ? void 0 : ref.phone
                }
            }));
        }
        (0,_utils_getWhatsAppRedirectionUrl__WEBPACK_IMPORTED_MODULE_5__/* .openWhatsAppLeadModal */ .iM)();
    };
    if (websiteStatus.isNewStoreWebsiteInactive) {
        return null;
    }
    return !!storePhone && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
        style: !(props === null || props === void 0 ? void 0 : props.overRideDefaultStyle) ? {
            position: "fixed",
            bottom: 32,
            right: 32
        } : null,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
            src: "/assets/images/whatsapp-round.svg",
            width: "48px",
            height: "48px",
            className: "pointer",
            alt: "Whatsapp",
            onClick: iconClick
        })
    });
};


/***/ })

}]);